import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.unshare-shared-notes', {
        url: '/remove-shared-notes',
        params: {notes: []},
        component: 'companyUserDirectoriesManageUserUnshareSharedNotes',
        resolve: {
            notes,
        },
    });
}

/** @ngInject */
function notes($stateParams) {
    return $stateParams.notes;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.state.js